import { render, staticRenderFns } from "./LargeLabelsNew.vue?vue&type=template&id=fc58f4ac&scoped=true"
import script from "./LargeLabelsNew.vue?vue&type=script&lang=js"
export * from "./LargeLabelsNew.vue?vue&type=script&lang=js"
import style0 from "./LargeLabelsNew.vue?vue&type=style&index=0&id=fc58f4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc58f4ac",
  null
  
)

export default component.exports